import { DownloadEpcisParams, DownloadInvoiceParams, UpdateBusinessLicenceBody } from '@core/models/image.model';
import API from 'services/api';
import { fetchWithRetry } from 'services/fetchWithRetry';

class ImageService {
    private readonly updateBusinessLicenceURL = `/image/business_licence`;
    private readonly updateResaleCertificateURL = `/image/resale_certificate`;
    private readonly updateStateBusinessLicenceURL = `/image/State_business_licence`;
    private readonly updateDeaCertificateURL = `/image/dea_certificate`;
    private readonly downloadInvoiceURL = `/image/download/invoice`;
    private readonly downloadEpcisURL = `/image/download/epcis`;

    // ---------------------------------------------------------------

    updateBusinessLicence(userId: number, body: UpdateBusinessLicenceBody) {
        const formData = new FormData();
        formData.append('file', body.file);

        return fetchWithRetry(
            API.patch(`${this.updateBusinessLicenceURL}/${userId}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
        );
    }

    updateResaleCertificate(userId: number, body: UpdateBusinessLicenceBody) {
        const formData = new FormData();
        formData.append('file', body.file);

        return fetchWithRetry(
            API.patch(`${this.updateResaleCertificateURL}/${userId}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
        );
    }

    updateStateBusinessLicence(userId: number, body: UpdateBusinessLicenceBody) {
        const formData = new FormData();
        formData.append('file', body.file);

        return fetchWithRetry(
            API.patch(`${this.updateStateBusinessLicenceURL}/${userId}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
        );
    }

    updateDeaCertificate(userId: number, body: UpdateBusinessLicenceBody) {
        const formData = new FormData();
        formData.append('file', body.file);

        return fetchWithRetry(
            API.patch(`${this.updateDeaCertificateURL}/${userId}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
        );
    }

    downloadInvoice(params: DownloadInvoiceParams) {
        return fetchWithRetry(API.get(`${this.downloadInvoiceURL}/${params.documentId}`, { responseType: 'blob' }));
    }

    downloadEpcis(params: DownloadEpcisParams) {
        return fetchWithRetry(API.get(`${this.downloadEpcisURL}/${params.urn}`, { responseType: 'blob' }));
    }
}

export default new ImageService();

